"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ObservableQueryMintingInfation = void 0;
const chain_query_1 = require("../../chain-query");
class ObservableQueryMintingInfation extends chain_query_1.ObservableChainQuery {
    constructor(kvStore, chainId, chainGetter) {
        super(kvStore, chainId, chainGetter, "/minting/inflation");
    }
}
exports.ObservableQueryMintingInfation = ObservableQueryMintingInfation;
//# sourceMappingURL=minting.js.map